'use strict';
module.exports = function (url) {

	var parseResult = new DOMParser().parseFromString(url || window.location.href, 'text/html'),
		parsedUrl = parseResult && parseResult.documentElement && parseResult.documentElement.textContent;

	var urlSpl = (url && url.includes('amp;') ? parsedUrl : url) || window.location.href,
		getSpl,
		getParams = {};

	urlSpl = urlSpl.split('#')[0];
	urlSpl = urlSpl.split('?');

	if (urlSpl.length < 2) {
		return false;
	}

	getSpl = urlSpl[1].split('&');
	getParams = {};

	getSpl.forEach(function (getFragment) {
		var getFragmentSpl = getFragment.split('=');

		if (getFragmentSpl.length > 1) {
			getParams[getFragmentSpl[0]] = decodeURIComponent(getFragmentSpl[1]);
		} else {
			getParams[getFragmentSpl[0]] = '';
		}
	});

	return getParams;
};



// WEBPACK FOOTER //
// ./src/components/utils/url/url-get-params.js